// src/GetFile.js

import React, { useEffect, useState } from "react";
import axios from "axios";

const GetFile = ({ fileName }) => {
  const [fileURL, setFileURL] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFile = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/view-file.php?fileName=${fileName}`,
          {
            responseType: "blob", // Important for file downloads
          }
        );

        // Create a URL for the file
        const url = URL.createObjectURL(response.data);
        setFileURL(url); // Set the file URL in state
      } catch (error) {
        console.error("Error fetching the file:", error);
        setError("Failed to fetch file."); // Set error in state
      } finally {
        setLoading(false); // Update loading state
      }
    };

    fetchFile();
  }, [fileName]); // Dependency array to re-fetch when fileName changes

  const renderFile = () => {
    const fileExtension = fileName.split(".").pop().toLowerCase();

    if (["jpg", "jpeg", "png", "gif", "bmp", "svg"].includes(fileExtension)) {
      return <img src={fileURL} alt={fileName} />;
    } else if (["mp4", "webm", "ogg"].includes(fileExtension)) {
      return <video controls src={fileURL} className="max-w-full h-auto" />;
    } else if (["pdf"].includes(fileExtension)) {
      return (
        <embed
          src={fileURL}
          type="application/pdf"
          width="100%"
          height="500px"
        />
      );
    } else {
      return <div>Unsupported file type</div>;
    }
  };

  if (loading) {
    return <div>Loading...</div>; // Display loading state
  }

  if (error) {
    return <div>{error}</div>; // Display error message
  }

  return <div>{fileURL ? renderFile() : <div>No file available</div>}</div>;
};

export default GetFile;
